import { useState } from "react";
import LeadsTable from './LeadsTable';
import SalesLayOut from '../SalesLayOut';

export default function SalesLead() {
    const [activeTab, setActiveTab] = useState("normalleads");

    return (
        <SalesLayOut>
            <LeadsTable leadsType="normalleads" setActiveTab={setActiveTab} />
        </SalesLayOut>
    )
}
